export type AccuCurrentWeather = {
  locationKey: string;
  observedAtIso: string | null;
  temperatureF: number | null;
  humidityPct: number | null;
  windSpeedMph: number | null;
  windGustMph: number | null;
  windDirectionDeg: number | null;
  windDirectionText: string | null;
};

const FETCH_TIMEOUT_MS = 8000;

async function fetchJson<T>(url: string): Promise<T> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);

  let res: Response;
  try {
    res = await fetch(url, { signal: controller.signal });
  } catch (err: any) {
    if (err?.name === "AbortError") {
      throw new Error(`Weather request timed out after ${FETCH_TIMEOUT_MS / 1000}s — check your connection`);
    }
    throw err;
  } finally {
    clearTimeout(timeoutId);
  }

  const text = await res.text();

  if (!res.ok) {
    throw new Error(`Weather request failed: ${res.status} ${text}`);
  }

  return JSON.parse(text) as T;
}

export async function getAccuCurrentConditionsByLatLng(
  lat: number,
  lng: number
): Promise<AccuCurrentWeather> {
  const url =
    `/.netlify/functions/weather` +
    `?lat=${encodeURIComponent(String(lat))}` +
    `&lng=${encodeURIComponent(String(lng))}`;

  return fetchJson<AccuCurrentWeather>(url);
}